import PropTypes from 'prop-types';

export const RangeFilterPropTypes = {
  activeCurrencyId: PropTypes.string,
  filterId: PropTypes.string,
  fragment: PropTypes.string,
  labels: PropTypes.shape({
    apply: PropTypes.string,
  }),
  url: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      results: PropTypes.number,
      url: PropTypes.string,
    }),
  ),
};

export const RangeFilterItemPropTypes = {
  className: PropTypes.string,
  handleChangeDropdown: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  pattern: PropTypes.string,
  setDropdownItemSelected: PropTypes.func.isRequired,
  type: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
};
